import { ChangeLog } from '@/domain/ChangeLog'

/**
 * ダッシュボード表示情報（月の情報）
 */
export class DashBoardMonth {
    /* 年月 YYYY/MM形式 */
    yearMonth = ""
    /* 受注金額 */
    ordersAmount = 0
    /* 売上見込金額 */
    expectedSalesAmount = 0
    /* 売上金額 */
    salesAmount = 0
    /* 依頼件数 */
    requestCount = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<DashBoardMonth>) {
        Object.assign(this, init)
    }
}

/**
 * ダッシュボード情報（担当情報）
 */
export class DashBoardUser {
    /* 担当者名 */
    userName = ""
    /* 売上金額 */
    salesAmount = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<DashBoardUser>) {
        Object.assign(this, init)
    }
}

/**
 * ダッシュボード表示情報
 */
export class DashBoard {
    /** 月の推移データ */
    monthSalesAmounts: DashBoardMonth[] = []

    /** 担当者別売上データ */
    userSalesAmounts: DashBoardUser[] = []

    /** 直近の変更 */
    changeLogs: ChangeLog[] = []

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<DashBoard>) {
        Object.assign(this, init)
    }
}
